import type { ComponentPropsWithoutRef } from "react";
import * as RadixTabs from "@radix-ui/react-tabs";
import s from "./Tabs.module.css";

export const Tabs = RadixTabs.Root;
export const TabsContent = RadixTabs.Content;

export type TabsListProps = ComponentPropsWithoutRef<typeof RadixTabs.List>;

export function TabsList({ className, ...rest }: TabsListProps) {
  const classes = className ? `${s.list} ${className}` : s.list;
  return <RadixTabs.List className={classes} {...rest} />;
}

export type TabsTriggerProps = ComponentPropsWithoutRef<typeof RadixTabs.Trigger>;

export function TabsTrigger({ className, ...rest }: TabsTriggerProps) {
  const classes = className ? `${s.trigger} ${className}` : s.trigger;
  return <RadixTabs.Trigger className={classes} {...rest} />;
}
